<template>
  <div class="" style="position:fixed">
    <b-container fluid style="padding-top: 100px;text-align:left">
          <b-row>
            <b-col cols="12 headerF"><HeaderConsumer/></b-col>
            <b-col cols="12 headerM"><HeaderConsumerMobile/></b-col>
          </b-row>

  <br>
        <b-row style="width:100vw;">

                <b-col col cols="12" sm="12" md="12" lg="12 " style="height:78vh; overflow-y:auto;text-align:left !important;padding-left:50px " class="shadow">
                <br>  <h1>  ADMIN DASHBOARD</h1>
                <hr>
                <br>

                  <b-row align="center" style="text-align:center !important ">
                    <b-col col cols="12" sm="12" md="4" lg="2" class="menuCol" id="ROLE_ADMIN" >
                      <router-link to="/AdminComplaintStatus">
                        <b-button class="menuItem" variant="info">ADMIN</b-button>
                      </router-link>
                    </b-col>
                      <b-col col cols="12" sm="12" md="4" lg="2" class="menuCol" id="ROLE_COMPLAINT" >
                        <router-link to="/AdminComplaintStatus">
                          <b-button class="menuItem" variant="info">Update Complaint <br> Status</b-button>
                        </router-link>
                      </b-col>
                      <b-col col cols="12" sm="12" md="4" lg="2" class="menuCol" id="ROLE_CONTACT">
                        <router-link to="/AdminUpdateContact">
                          <b-button class="menuItem" variant="info">Update <br> Contact</b-button>
                        </router-link>
                      </b-col>
                      <b-col col cols="12" sm="12" md="4" lg="2" class="menuCol" id="ROLE_TENDER" >
                        <router-link to="/AdminCreateTender">
                            <b-button class="menuItem" variant="info">Update <br> Tender</b-button>
                        </router-link>
                      </b-col>
                      <b-col col cols="12" sm="12" md="4" lg="2" class="menuCol" id="ROLE_DOCUMENT">
                        <b-button class="menuItem" variant="info">Update <br> Documents</b-button>
                      </b-col>
                      <b-col col cols="12" sm="12" md="4" lg="2" class="menuCol" id="ROLE_CAREER" >
                        <b-button class="menuItem" variant="info">Update <br> Career</b-button>
                      </b-col>
                      <b-col col cols="12" sm="12" md="4" lg="2" class="menuCol" id="ROLE_NEWS">
                        <b-button class="menuItem" variant="info">Update News <br> and Media</b-button>
                        </b-col>
                  </b-row>
                </b-col>
      </b-row>
    </b-container>
   <br><br>
  </div>
</template>

<script>
import AdminSideNav from '@/components/AdminSideNav.vue'
import HeaderConsumer from '@/components/HeaderConsumer.vue'
import HeaderConsumerMobile from '@/components/HeaderConsumerMobile.vue'
import axios from 'axios'

//var urlCommon = "https://portald.apdcl.org/website";
var urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";

export default {
  name: 'Admin',
  components: {
    'AdminSideNav' : AdminSideNav,
    'HeaderConsumer' : HeaderConsumer,
    'HeaderConsumerMobile' : HeaderConsumerMobile

  },
  methods:
  {
    insertComplaint(){
      var type = document.getElementById("type").value;
      var source = document.getElementById("source").value;
      var description = document.getElementById("description").value;
      var action = document.getElementById("action").value;
      var resolved_date = document.getElementById("resolved_date").value;
      var feedback = document.getElementById("feedback").value;

      console.log(type+"::"+source+"::"+description+"::"+action+"::"+resolved_date+"::"+feedback)

/*      if(user == ""){
        this.$bvToast.toast('User Id can not be empty !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return
      }
      if(pw.value == ""){
        this.$bvToast.toast('Password can not be empty !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return
      }

      var dataToSend = {
        "user_id": user_id.value,
        "password": pw.value
      }
      console.log(dataToSend);
*/
    //  var parent = this;
    //  parent.show=true;
          axios.post(urlCommon + "/api/admin/putComplaintStatus?type="+type+"&source="+source+"&description="+description+"&action="+action+"&resolved_date="+resolved_date+"&feedback="+feedback).then(function(response) {
        //    parent.show=false;
            console.log (response.data )


          });


    }
  },
  mounted()
  {
  //  var userId = localStorage.getItem("userId");
  //  var userName = localStorage.getItem("userName");
    var roles = localStorage.getItem("roleSet");
  
    // if(userId == null)
    //   {
    //     this.$router.push({ path: '/' })
    //     return;
    //   }
    var i =0;
    var res= roles.split(",");

     for(i=0;i<res.length;i++)
     {
       console.log(res[i])
       if(res[i]!="ROLE_ADMIN")
       document.getElementById(res[i]).style.display="block";
     }

  //    document.getElementById("consName").innerHTML = userName ;
  //    document.getElementById("consNameMb").innerHTML = userName ;


  }

}


</script>

<style scoped="true">
body{
  overflow-y:hidden !important;
}
.menuCol
{
 display:none;
}
.menuItem
{
  border-radius: 50%;
  height:10rem;
  width:10rem;
  margin-top:1rem;
}
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;
  color: #6a1b9a ;
}

li{
  padding:0;
}

    body{
      overflow-y:hidden;
    }
.shadow{}
  .headerF{
  display: block;
}
.headerM{
  display: none;
}
.sideNav{
  height:75vh;
  overflow-y:auto;
}
.dropdownmenu{
  display: none;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .sideNav{
      /* height:50vh;
      overflow-y:hidden; */
      display: none
    }
    .dropdownmenu{
      display: block;
    }
  }
  @media (max-width: 576px) {
    .sideNav{
      /* height:50vh;
      overflow-y:hidden; */
      display: none
    }
    .dropdownmenu{
      display: block;
    }
  }
</style>
